

export const pluralize = (amount: number, singular: string, plural: string, zeroAmountOverride : string|undefined = undefined, signed: boolean | 'always' = false): string =>{
  if(Math.abs(amount)===1){
    return (signed ? signedFormat(amount, signed === 'always') : amount.toString()) + " " + singular
  }

  if (amount===0 && zeroAmountOverride !== undefined) {
    return zeroAmountOverride+" "+plural
  }

  return (signed ? signedFormat(amount, signed === 'always') : amount.toString()) + " " + plural

}

export const pluralizeUnitOnly = (amount: number, singular: string, plural: string, zero: string|null = null): string =>{
    if(amount===0 && !!zero){
        return zero
    }
  if(amount===1){
    return singular
  }
  return plural
}

export const pluralizeHuman = (amount: number, singularFull: string, pluralSuffix: string, zeroAmountOverrideFull : string|undefined = undefined): string => {
    if(amount===1) {
        return singularFull
    }

    if (amount===0 && zeroAmountOverrideFull !== undefined) {
        return zeroAmountOverrideFull
    }

    if (amount === 2) {
        return 'zwei ' + pluralSuffix
    }

    if (amount === 3) {
        return 'drei ' + pluralSuffix
    }

    return amount.toString() + " " + pluralSuffix

}

export const listFormat = (items: string[], options : Intl.ListFormatOptions = {style: 'long', type:'conjunction'}, locale: string = 'de'): string => {
    // use localized formatter to get "a, b und c"
    const formatter = new Intl.ListFormat(locale, options);

    if (options.style === 'short' && locale === 'de') {
        console.warn("listFormat(de) never uses '&' - maybe switch to 'en': ", formatter.format(items))
    }

    return formatter.format(items)
}

export const signedFormat = (amount: number, showPlus:boolean, showPlusMinusZero = false): string => {
    let sign = ''
    if (amount<0) {
        sign = '-'
    } else if (amount>0 && showPlus) {
        sign = '+'
    } else if (amount == 0) {
        sign = '+-'
    }
    return sign + amount.toString()
}

export const floatFormat = (amount: number, fractionalDigits = 1): string => {
    return new Intl.NumberFormat("de-DE", {maximumFractionDigits: fractionalDigits}).format(amount)
}

export function ucfirst(val: string) : string {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
